export const PullCommand = Object.freeze({
	messageUpdate: 'messageUpdate',
	messageDelete: 'messageDelete'
});

export const PullHandlers = Object.freeze({
	recent: 'recent',
	notification: 'notification',
	sidebar: 'sidebar',
});